import React from 'react'
import PropTypes from 'prop-types'

// Components
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import ItineraryItem from '../ItineraryItem'
import ScrollSection from '../ScrollSection'
import Spacer from '../Spacer'
import AnimateSplitText from '../animation/AnimateSplitText'

// Vars
import { Heading3 } from '../../styles/vars/textStyles.style'

// Styles
import {
  ItineraryWrapper,
  ItineraryHeading,
  ItineraryListWrap,
  ItineraryList,
} from './index.style'
import { colors } from '../../styles/vars/colors.style'
import Button from '../Button'

const ItinerarySection = ({
  id,
  month,
  year,
  data,
  pdf,
  linkId,
  translations,
}) => {
  return (
    <ScrollSection threshold={0}>
      <ItineraryWrapper id={linkId && linkId}>
        <Container>
          <Grid>
            <GridItem mobile={8} tabletL={3} desk={2} deskStart={2}>
              <ItineraryHeading>
                <Heading3 as={`h2`}>
                  <AnimateSplitText id={id + `-heading`} delayEm={true}>
                    <>
                      {month}
                      <br />
                      <em>{year}</em>
                    </>
                  </AnimateSplitText>
                </Heading3>

                {pdf && (
                  <>
                    <Spacer size={24} />
                    <AnimateSplitText id={id + `-pdf`} delay={1}>
                      <Button
                        href={pdf.file.url}
                        variant="underline"
                        color={colors.dark}
                      >
                        {translations.printFullItinerary}
                      </Button>
                    </AnimateSplitText>

                    <Spacer size={[24, 0]} />
                  </>
                )}
              </ItineraryHeading>
            </GridItem>
            <GridItem tabletL={8}>
              <ItineraryListWrap>
                <ItineraryList>
                  {data.map((item, key) => (
                    <ItineraryItem
                      key={key}
                      id={id + '-' + key}
                      translations={translations}
                      {...item}
                    />
                  ))}
                </ItineraryList>
              </ItineraryListWrap>
            </GridItem>
          </Grid>
        </Container>
        <Spacer size={[100, 250]} />
      </ItineraryWrapper>
    </ScrollSection>
  )
}

ItinerarySection.propTypes = {
  id: PropTypes.number.isRequired,
  month: PropTypes.string,
  year: PropTypes.string,
  data: PropTypes.array,
}

export default ItinerarySection
